var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _path7, _circle, _circle2, _circle3, _path8, _g4, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _g5, _path15, _path16, _path17, _path18, _path19, _path20, _g6, _path21, _g7, _g8, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberPlatinum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 171,
    viewBox: "0 0 324 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_96950)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "url(#paint0_linear_374_96950)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_96950)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144.29,
    cy: 115.58,
    r: 71.3694,
    stroke: "url(#paint1_linear_374_96950)",
    strokeOpacity: 0.08,
    strokeWidth: 24.1346
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.456,
    cy: -13.7187,
    r: 85.8271,
    stroke: "url(#paint2_linear_374_96950)",
    strokeOpacity: 0.08,
    strokeWidth: 29.0236
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_374_96950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.32 -4.88543C220.32 52.3755 173.901 98.7946 116.64 98.7946C59.3791 98.7946 12.96 52.3755 12.96 -4.88543C12.96 -62.1463 59.3791 -108.565 116.64 -108.565C173.901 -108.565 220.32 -62.1463 220.32 -4.88543Z",
    fill: "url(#paint3_radial_374_96950)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 320.856,
    cy: 220.622,
    r: 102.481,
    stroke: "url(#paint4_linear_374_96950)",
    strokeOpacity: 0.08,
    strokeWidth: 38.6935
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.194 23.5383C386.615 51.7683 373.736 94.5986 337.753 120.628C301.868 146.587 258.296 144.264 237.819 115.957C217.236 87.5034 227.223 41.9449 262.929 16.1151C298.637 -9.7156 345.611 -4.91448 366.194 23.5383Z",
    stroke: "#1B1A1A",
    strokeWidth: 6.46129
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.2 8.87626C389.995 44.1854 382.299 86.8792 340.851 120.517C298.174 151.985 251.879 144.394 227.546 113.444C203.213 82.4934 212.137 31.0455 249.927 3.70892C287.716 -23.6277 337.782 -22.1135 360.2 8.87626Z",
    fill: "url(#paint5_linear_374_96950)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.843 8.05579C366.08 22.2062 367.773 40.0091 362.241 57.7807C356.7 75.576 343.934 93.1871 325.555 106.482C288.59 133.222 244.247 131.37 223.811 103.12C203.271 74.7264 213.96 28.5691 250.745 1.95905C287.531 -24.6519 335.304 -20.337 355.843 8.05579Z",
    stroke: "#2C2C2C",
    strokeWidth: 6.46129
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.59 8.10005C364.519 31.5027 355.012 71.7831 319.573 97.4199C284.133 123.057 242.9 119.481 225.971 96.0783C209.042 72.6756 218.549 32.3953 253.989 6.75843C289.428 -18.8784 330.661 -15.3026 347.59 8.10005Z",
    fill: "#222221",
    stroke: "url(#paint6_linear_374_96950)",
    strokeWidth: 17.948
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.107 88.4702L254.601 61.2299L317.655 69.0684L291.107 88.4702Z",
    fill: "#2F2F2E",
    stroke: "#222221",
    strokeWidth: 0.925714
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.197 60.7696L301.212 34.6L290.531 87.4742L254.197 60.7696Z",
    fill: "#2F2F2E",
    stroke: "#222221",
    strokeWidth: 0.925714
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_374_96950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    fill: "#2F2F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    stroke: "#222221",
    strokeWidth: 0.925714
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_374_96950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    fill: "#2F2F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    stroke: "#222221",
    strokeWidth: 0.925714
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.341 60.7148L284.724 83.7799L263.932 29.585L253.341 60.7148Z",
    fill: "#2F2F2E",
    stroke: "#222221",
    strokeWidth: 0.925714
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301.403,
    cy: 33.7749,
    r: 4.05936,
    transform: "rotate(36.3143 301.403 33.7749)",
    fill: "#2F2F2E",
    stroke: "#222221",
    strokeWidth: 0.462857
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.193,
    cy: 69.1391,
    r: 3.39924,
    transform: "rotate(36.3143 317.193 69.1391)",
    fill: "#2F2F2E",
    stroke: "#222221",
    strokeWidth: 0.462857
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.15,
    cy: 30.155,
    r: 3.39924,
    transform: "rotate(-8.68571 264.15 30.155)",
    fill: "#2F2F2E",
    stroke: "#222221",
    strokeWidth: 0.462857
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.91 14.4083C346.197 24.4827 347.156 37.85 342.578 51.456C338.001 65.0586 327.915 78.7753 313.354 89.3093C298.792 99.8433 282.608 105.13 268.256 105.22C253.901 105.31 241.505 100.216 234.217 90.1421C226.929 80.0677 225.97 66.7003 230.549 53.0944C235.126 39.4917 245.211 25.775 259.773 15.241C274.335 4.70705 290.519 -0.579367 304.871 -0.66974C319.226 -0.760135 331.622 4.33388 338.91 14.4083Z",
    stroke: "url(#paint7_linear_374_96950)",
    strokeWidth: 2.87168
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_374_96950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.786 47.728L378.34 64.547C381.61 45.3291 374.46 29.9472 371.65 25.68C369.426 21.5115 365.3 15.656 360.441 9.23124C347.545 -10.9302 320.361 -28.912 278.102 -15.4846C227.842 1.80048 211.183 42.5319 209.396 60.5175L363.49 45.7588L367.786 47.728Z",
    fill: "#545454",
    fillOpacity: 0.08
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddddd_374_96950)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 47.8232,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "url(#paint8_radial_374_96950)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint9_linear_374_96950)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7939 58.7772L29.7776 52.8262L31.7613 58.7772H27.7939Z",
    fill: "url(#paint10_linear_374_96950)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7773 52.8262L31.761 58.7772H34.4059L29.7773 52.8262Z",
    fill: "url(#paint11_linear_374_96950)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7284L25.1484 58.7773H27.7933L29.777 64.7284Z",
    fill: "url(#paint12_linear_374_96950)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7613 58.7773H27.7939L29.7776 64.7284L31.7613 58.7773Z",
    fill: "url(#paint13_linear_374_96950)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.761 58.7773H34.4059L29.7773 64.7284L31.761 58.7773Z",
    fill: "url(#paint14_linear_374_96950)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_374_96950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "black",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 52.8262L31.7607 58.7772H34.4056L29.777 52.8262Z",
    fill: "black",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 58.7772L29.777 52.8262L31.7607 58.7772H27.7933Z",
    fill: "black",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7282L25.1484 58.7772H27.7933L29.777 64.7282Z",
    fill: "black",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H34.4056L29.777 64.7282L31.7607 58.7772Z",
    fill: "black",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H27.7933L29.777 64.7282L31.7607 58.7772Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_96950)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_374_96950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 52,
    width: 10,
    height: 13
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint15_linear_374_96950)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 52.8262L31.7607 58.7772H34.4056L29.777 52.8262Z",
    fill: "url(#paint16_linear_374_96950)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 58.7772L29.777 52.8262L31.7607 58.7772H27.7933Z",
    fill: "url(#paint17_linear_374_96950)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7282L25.1484 58.7772H27.7933L29.777 64.7282Z",
    fill: "url(#paint18_linear_374_96950)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H34.4056L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint19_linear_374_96950)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H27.7933L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint20_linear_374_96950)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_374_96950)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_374_96950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7909 52.8306L27.8072 58.7816L27.7793 58.7723L29.763 52.8213L29.7909 52.8306Z",
    fill: "url(#paint21_linear_374_96950)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7627 64.7235L31.7464 58.7725L31.7742 58.7818L29.7906 64.7328L29.7627 64.7235Z",
    fill: "url(#paint22_linear_374_96950)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_374_96950)",
    filter: "url(#filter7_f_374_96950)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_374_96950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 52,
    width: 5,
    height: 7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7483 52.8262L27.7646 58.7258H31.7834L29.7483 52.8262Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.0146939
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_374_96950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.1953,
    y: 33.9453,
    width: 0.861728,
    height: 46.9824,
    transform: "rotate(30.433 42.1953 33.9453)",
    fill: "#484848",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 35.8389,
    width: 1.27325,
    height: 45.5408,
    transform: "rotate(30.433 42.8672 35.8389)",
    fill: "#484848",
    fillOpacity: 0.2
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_374_96950)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.7769,
    cy: 53.273,
    rx: 0.330612,
    ry: 0.446843,
    fill: "url(#paint23_linear_374_96950)"
  })))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0477 61.6122V59.5793H56.5804C56.9026 59.5793 57.1969 59.5127 57.4635 59.3794C57.7301 59.2461 57.9412 59.0517 58.0967 58.7962C58.2523 58.5407 58.33 58.2296 58.33 57.863C58.33 57.5076 58.2523 57.2021 58.0967 56.9466C57.9412 56.6911 57.7301 56.4967 57.4635 56.3634C57.1969 56.2301 56.9026 56.1634 56.5804 56.1634H54.0477V54.1306H56.9637C57.7079 54.1306 58.38 54.2805 58.9799 54.5805C59.5797 54.8804 60.0518 55.3136 60.3962 55.8802C60.7517 56.4356 60.9294 57.0965 60.9294 57.863C60.9294 58.6295 60.7517 59.296 60.3962 59.8626C60.0518 60.418 59.5797 60.8512 58.9799 61.1623C58.38 61.4622 57.7079 61.6122 56.9637 61.6122H54.0477ZM52.0481 65.8945V54.1306H54.6642V65.8945H52.0481ZM62.2779 65.8945V53.7973H64.8274V65.8945H62.2779ZM70.0052 66.0612C69.2609 66.0612 68.5944 65.8779 68.0057 65.5113C67.428 65.1447 66.967 64.6448 66.6226 64.0116C66.2894 63.3784 66.1228 62.6564 66.1228 61.8455C66.1228 61.0345 66.2894 60.3125 66.6226 59.6793C66.967 59.0461 67.428 58.5462 68.0057 58.1796C68.5944 57.813 69.2609 57.6298 70.0052 57.6298C70.5495 57.6298 71.0383 57.7353 71.4715 57.9463C71.9159 58.1574 72.2769 58.4518 72.5546 58.8295C72.8323 59.1961 72.9879 59.6182 73.0212 60.0959V63.5951C72.9879 64.0727 72.8323 64.5004 72.5546 64.8781C72.288 65.2447 71.9325 65.5335 71.4882 65.7446C71.0439 65.9556 70.5495 66.0612 70.0052 66.0612ZM70.5218 63.7617C71.0661 63.7617 71.5049 63.5839 71.8381 63.2285C72.1714 62.8619 72.338 62.4009 72.338 61.8455C72.338 61.4678 72.2602 61.1345 72.1047 60.8457C71.9603 60.5569 71.7493 60.3347 71.4715 60.1792C71.2049 60.0125 70.8939 59.9292 70.5384 59.9292C70.1829 59.9292 69.8663 60.0125 69.5886 60.1792C69.322 60.3347 69.1054 60.5569 68.9388 60.8457C68.7833 61.1345 68.7055 61.4678 68.7055 61.8455C68.7055 62.212 68.7833 62.5397 68.9388 62.8286C69.0943 63.1174 69.3109 63.3451 69.5886 63.5117C69.8663 63.6784 70.1774 63.7617 70.5218 63.7617ZM72.238 65.8945V63.7117L72.6213 61.7455L72.238 59.7793V57.7964H74.7375V65.8945H72.238ZM77.6822 65.8945V54.4471H80.2316V65.8945H77.6822ZM75.8493 59.9626V57.7964H82.0646V59.9626H75.8493ZM83.1879 65.8945V57.7964H85.7373V65.8945H83.1879ZM84.4709 56.68C84.071 56.68 83.7377 56.5467 83.4711 56.2801C83.2156 56.0023 83.0879 55.6691 83.0879 55.2803C83.0879 54.8804 83.2156 54.5471 83.4711 54.2805C83.7377 54.0139 84.071 53.8806 84.4709 53.8806C84.8708 53.8806 85.1985 54.0139 85.454 54.2805C85.7095 54.5471 85.8373 54.8804 85.8373 55.2803C85.8373 55.6691 85.7095 56.0023 85.454 56.2801C85.1985 56.5467 84.8708 56.68 84.4709 56.68ZM92.8814 65.8945V61.2789C92.8814 60.8568 92.7481 60.518 92.4814 60.2625C92.2259 59.9959 91.8982 59.8626 91.4983 59.8626C91.2206 59.8626 90.9762 59.9237 90.7652 60.0459C90.5541 60.157 90.3875 60.3236 90.2653 60.5458C90.1431 60.7568 90.082 61.0012 90.082 61.2789L89.0989 60.7957C89.0989 60.1625 89.2377 59.6071 89.5155 59.1294C89.7932 58.6517 90.1764 58.2852 90.6652 58.0297C91.1651 57.7631 91.7261 57.6298 92.3481 57.6298C92.948 57.6298 93.4757 57.7742 93.9311 58.063C94.3977 58.3407 94.7643 58.7128 95.0309 59.1794C95.2975 59.646 95.4308 60.157 95.4308 60.7124V65.8945H92.8814ZM87.5326 65.8945V57.7964H90.082V65.8945H87.5326ZM100.667 66.0778C99.9231 66.0778 99.2621 65.9279 98.6845 65.6279C98.1179 65.3169 97.6736 64.8948 97.3514 64.3615C97.0293 63.8172 96.8682 63.1951 96.8682 62.4953V57.7964H99.4176V62.462C99.4176 62.7397 99.4621 62.9785 99.5509 63.1785C99.6509 63.3784 99.7953 63.534 99.9842 63.645C100.173 63.7561 100.401 63.8117 100.667 63.8117C101.045 63.8117 101.345 63.695 101.567 63.4618C101.789 63.2174 101.9 62.8841 101.9 62.462V57.7964H104.45V62.4786C104.45 63.1896 104.289 63.8172 103.967 64.3615C103.644 64.8948 103.2 65.3169 102.634 65.6279C102.067 65.9279 101.412 66.0778 100.667 66.0778ZM106.05 65.8945V57.7964H108.6V65.8945H106.05ZM111.233 65.8945V61.1623C111.233 60.7513 111.105 60.4347 110.849 60.2125C110.605 59.9792 110.3 59.8626 109.933 59.8626C109.677 59.8626 109.45 59.9181 109.25 60.0292C109.05 60.1292 108.889 60.2736 108.767 60.4624C108.655 60.6513 108.6 60.8846 108.6 61.1623L107.617 60.729C107.617 60.0847 107.756 59.5349 108.033 59.0794C108.311 58.6129 108.689 58.2574 109.166 58.013C109.644 57.7575 110.183 57.6298 110.783 57.6298C111.349 57.6298 111.855 57.7575 112.299 58.013C112.755 58.2685 113.116 58.624 113.382 59.0794C113.649 59.5349 113.782 60.0792 113.782 60.7124V65.8945H111.233ZM116.415 65.8945V61.1623C116.415 60.7513 116.287 60.4347 116.032 60.2125C115.787 59.9792 115.482 59.8626 115.115 59.8626C114.86 59.8626 114.632 59.9181 114.432 60.0292C114.232 60.1292 114.071 60.2736 113.949 60.4624C113.838 60.6513 113.782 60.8846 113.782 61.1623L112.316 60.9623C112.338 60.2736 112.499 59.6848 112.799 59.1961C113.11 58.6962 113.515 58.3129 114.015 58.0463C114.526 57.7686 115.098 57.6298 115.732 57.6298C116.354 57.6298 116.904 57.7631 117.381 58.0297C117.87 58.2852 118.253 58.6573 118.531 59.1461C118.82 59.6237 118.964 60.2014 118.964 60.879V65.8945H116.415ZM124.004 65.8945V54.1306H125.871L130.503 61.3456H129.553L134.169 54.1306H136.052V65.8945H133.435V58.5462L133.902 58.6629L130.886 63.3618H129.153L126.154 58.6629L126.604 58.5462V65.8945H124.004ZM142.073 66.0778C141.196 66.0778 140.413 65.9001 139.724 65.5446C139.046 65.178 138.513 64.6726 138.124 64.0283C137.736 63.384 137.541 62.6564 137.541 61.8455C137.541 61.0345 137.73 60.3125 138.108 59.6793C138.497 59.035 139.019 58.5295 139.674 58.163C140.329 57.7964 141.068 57.6131 141.89 57.6131C142.69 57.6131 143.395 57.7853 144.006 58.1296C144.617 58.474 145.095 58.9517 145.439 59.5626C145.795 60.1736 145.973 60.8735 145.973 61.6622C145.973 61.8066 145.961 61.9621 145.939 62.1287C145.928 62.2842 145.9 62.4675 145.856 62.6786L138.874 62.6953V60.9457L144.773 60.929L143.673 61.6622C143.662 61.1956 143.59 60.8124 143.457 60.5124C143.323 60.2014 143.123 59.9681 142.857 59.8126C142.601 59.646 142.285 59.5626 141.907 59.5626C141.507 59.5626 141.157 59.6571 140.857 59.8459C140.568 60.0237 140.341 60.2791 140.174 60.6124C140.018 60.9457 139.941 61.3511 139.941 61.8288C139.941 62.3065 140.024 62.7175 140.191 63.0618C140.368 63.3951 140.613 63.6562 140.924 63.845C141.246 64.0227 141.624 64.1116 142.057 64.1116C142.457 64.1116 142.818 64.045 143.14 63.9117C143.462 63.7672 143.745 63.5562 143.99 63.2785L145.389 64.6781C144.989 65.1447 144.506 65.4946 143.94 65.7279C143.373 65.9612 142.751 66.0778 142.073 66.0778ZM147.203 65.8945V57.7964H149.753V65.8945H147.203ZM152.385 65.8945V61.1623C152.385 60.7513 152.258 60.4347 152.002 60.2125C151.758 59.9792 151.452 59.8626 151.086 59.8626C150.83 59.8626 150.602 59.9181 150.402 60.0292C150.202 60.1292 150.041 60.2736 149.919 60.4624C149.808 60.6513 149.753 60.8846 149.753 61.1623L148.769 60.729C148.769 60.0847 148.908 59.5349 149.186 59.0794C149.464 58.6129 149.841 58.2574 150.319 58.013C150.797 57.7575 151.336 57.6298 151.935 57.6298C152.502 57.6298 153.007 57.7575 153.452 58.013C153.907 58.2685 154.268 58.624 154.535 59.0794C154.801 59.5349 154.935 60.0792 154.935 60.7124V65.8945H152.385ZM157.567 65.8945V61.1623C157.567 60.7513 157.44 60.4347 157.184 60.2125C156.94 59.9792 156.634 59.8626 156.268 59.8626C156.012 59.8626 155.785 59.9181 155.585 60.0292C155.385 60.1292 155.224 60.2736 155.101 60.4624C154.99 60.6513 154.935 60.8846 154.935 61.1623L153.468 60.9623C153.491 60.2736 153.652 59.6848 153.952 59.1961C154.263 58.6962 154.668 58.3129 155.168 58.0463C155.679 57.7686 156.251 57.6298 156.884 57.6298C157.506 57.6298 158.056 57.7631 158.534 58.0297C159.023 58.2852 159.406 58.6573 159.684 59.1461C159.972 59.6237 160.117 60.2014 160.117 60.879V65.8945H157.567ZM166.416 66.0612C165.872 66.0612 165.372 65.9501 164.917 65.7279C164.461 65.4946 164.089 65.1891 163.8 64.8114C163.511 64.4226 163.345 63.9894 163.3 63.5117V60.0959C163.345 59.6182 163.511 59.1961 163.8 58.8295C164.089 58.4518 164.461 58.1574 164.917 57.9463C165.372 57.7353 165.872 57.6298 166.416 57.6298C167.183 57.6298 167.86 57.813 168.449 58.1796C169.049 58.5462 169.516 59.0461 169.849 59.6793C170.193 60.3125 170.365 61.0345 170.365 61.8455C170.365 62.6564 170.193 63.3784 169.849 64.0116C169.516 64.6448 169.049 65.1447 168.449 65.5113C167.86 65.8779 167.183 66.0612 166.416 66.0612ZM165.966 63.7617C166.322 63.7617 166.633 63.6784 166.899 63.5117C167.177 63.3451 167.394 63.1174 167.549 62.8286C167.705 62.5397 167.783 62.212 167.783 61.8455C167.783 61.4678 167.705 61.1345 167.549 60.8457C167.394 60.5569 167.177 60.3347 166.899 60.1792C166.633 60.0125 166.322 59.9292 165.966 59.9292C165.611 59.9292 165.294 60.0125 165.017 60.1792C164.739 60.3347 164.522 60.5569 164.367 60.8457C164.222 61.1345 164.15 61.4678 164.15 61.8455C164.15 62.2231 164.228 62.5564 164.383 62.8452C164.539 63.1341 164.75 63.3618 165.017 63.5284C165.294 63.6839 165.611 63.7617 165.966 63.7617ZM161.751 65.8945V53.7973H164.3V59.7793L163.883 61.7455L164.267 63.7117V65.8945H161.751ZM175.66 66.0778C174.782 66.0778 173.999 65.9001 173.31 65.5446C172.632 65.178 172.099 64.6726 171.71 64.0283C171.322 63.384 171.127 62.6564 171.127 61.8455C171.127 61.0345 171.316 60.3125 171.694 59.6793C172.083 59.035 172.605 58.5295 173.26 58.163C173.916 57.7964 174.654 57.6131 175.476 57.6131C176.276 57.6131 176.981 57.7853 177.592 58.1296C178.203 58.474 178.681 58.9517 179.025 59.5626C179.381 60.1736 179.559 60.8735 179.559 61.6622C179.559 61.8066 179.548 61.9621 179.525 62.1287C179.514 62.2842 179.486 62.4675 179.442 62.6786L172.46 62.6953V60.9457L178.359 60.929L177.259 61.6622C177.248 61.1956 177.176 60.8124 177.043 60.5124C176.909 60.2014 176.709 59.9681 176.443 59.8126C176.187 59.646 175.871 59.5626 175.493 59.5626C175.093 59.5626 174.743 59.6571 174.443 59.8459C174.154 60.0237 173.927 60.2791 173.76 60.6124C173.604 60.9457 173.527 61.3511 173.527 61.8288C173.527 62.3065 173.61 62.7175 173.777 63.0618C173.954 63.3951 174.199 63.6562 174.51 63.845C174.832 64.0227 175.21 64.1116 175.643 64.1116C176.043 64.1116 176.404 64.045 176.726 63.9117C177.048 63.7672 177.331 63.5562 177.576 63.2785L178.975 64.6781C178.576 65.1447 178.092 65.4946 177.526 65.7279C176.959 65.9612 176.337 66.0778 175.66 66.0778ZM180.789 65.8945V57.7964H183.339V65.8945H180.789ZM183.339 61.4455L182.272 60.6124C182.483 59.6682 182.839 58.935 183.339 58.4129C183.839 57.8908 184.533 57.6298 185.422 57.6298C185.81 57.6298 186.149 57.6909 186.438 57.813C186.738 57.9241 186.999 58.1019 187.221 58.3463L185.705 60.2625C185.594 60.1403 185.455 60.0459 185.288 59.9792C185.122 59.9126 184.933 59.8792 184.722 59.8792C184.3 59.8792 183.961 60.0125 183.705 60.2791C183.461 60.5346 183.339 60.9234 183.339 61.4455Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_374_96950",
    x: -46.6972,
    y: -168.223,
    width: 326.675,
    height: 326.675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.8286,
    result: "effect1_foregroundBlur_374_96950"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_374_96950",
    x: 274.534,
    y: 34.6593,
    width: 23.8025,
    height: 15.5759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925714,
    result: "effect1_foregroundBlur_374_96950"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_374_96950",
    x: 261.692,
    y: 40.5593,
    width: 33.8629,
    height: 53.6393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.62857,
    result: "effect1_foregroundBlur_374_96950"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_374_96950",
    x: 208.47,
    y: -21.0546,
    width: 171.635,
    height: 86.5272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.462857,
    result: "effect1_foregroundBlur_374_96950"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddddd_374_96950",
    x: -51.8396,
    y: 23.7547,
    width: 163.851,
    height: 163.851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973442
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.037943 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_96950"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.33932
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0479222 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_374_96950",
    result: "effect2_dropShadow_374_96950"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40472
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0544001 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_374_96950",
    result: "effect3_dropShadow_374_96950"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.85728
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0602938 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_374_96950",
    result: "effect4_dropShadow_374_96950"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.3371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6962
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0681504 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_374_96950",
    result: "effect5_dropShadow_374_96950"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 46.2857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.1771
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_374_96950",
    result: "effect6_dropShadow_374_96950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_374_96950",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_374_96950",
    x: 25.1484,
    y: 52.7086,
    width: 9.25684,
    height: 12.1521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.132245
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117551
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2625 0 0 0 0 0.241719 0 0 0 0 0.241719 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_374_96950"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.117551
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.36
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_374_96950",
    result: "effect2_innerShadow_374_96950"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_374_96950",
    x: 27.1915,
    y: 52.2335,
    width: 3.18723,
    height: 7.13547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.293878
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_374_96950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_374_96950",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_374_96950",
    x: 27.412,
    y: 52.4735,
    width: 4.72386,
    height: 6.60472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.176327,
    result: "effect1_foregroundBlur_374_96950"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_374_96950",
    x: 28.7851,
    y: 52.1649,
    width: 1.98358,
    height: 2.216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.330612,
    result: "effect1_foregroundBlur_374_96950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_374_96950",
    x1: 54.6171,
    y1: -7.46051,
    x2: 188.809,
    y2: 205.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491094,
    stopColor: "#2C2D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692555,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_374_96950",
    x1: 144.29,
    y1: 32.1436,
    x2: 129.982,
    y2: 195.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_374_96950",
    x1: 375.65,
    y1: -73.4245,
    x2: 296.249,
    y2: 82.8886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.520347,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_374_96950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.64 -4.88543) rotate(90) scale(103.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101010",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_374_96950",
    x1: 235.778,
    y1: 197.465,
    x2: 215.641,
    y2: 175.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_374_96950",
    x1: 193.011,
    y1: 150.91,
    x2: 338.287,
    y2: 122.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#1E1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_374_96950",
    x1: 328.628,
    y1: 23.6236,
    x2: 243,
    y2: 116.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448567,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_374_96950",
    x1: 259.654,
    y1: 11.132,
    x2: 318.57,
    y2: 89.1705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474971,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_374_96950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0861 59.3947) rotate(90) scale(11.5714)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_374_96950",
    x1: 29.777,
    y1: 52.8262,
    x2: 23.7295,
    y2: 55.2796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242423"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_374_96950",
    x1: 29.7776,
    y1: 52.8262,
    x2: 29.7776,
    y2: 58.7772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_374_96950",
    x1: 29.7773,
    y1: 52.8262,
    x2: 35.8249,
    y2: 55.2792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#3C3D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_374_96950",
    x1: 25.1484,
    y1: 58.7773,
    x2: 29.5638,
    y2: 64.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#3D3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_374_96950",
    x1: 28.8519,
    y1: 64.5519,
    x2: 30.5255,
    y2: 57.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_374_96950",
    x1: 34.4059,
    y1: 58.7773,
    x2: 29.9905,
    y2: 64.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#4F4F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31332C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_374_96950",
    x1: 34.4056,
    y1: 52.8262,
    x2: 22.3105,
    y2: 57.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_374_96950",
    x1: 25.1484,
    y1: 52.8262,
    x2: 37.2436,
    y2: 57.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_374_96950",
    x1: 29.777,
    y1: 52.8262,
    x2: 29.777,
    y2: 64.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_374_96950",
    x1: 25.1484,
    y1: 52.8262,
    x2: 33.9792,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_374_96950",
    x1: 34.4056,
    y1: 52.8262,
    x2: 25.5748,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_374_96950",
    x1: 29.777,
    y1: 58.7772,
    x2: 29.0351,
    y2: 64.6342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_374_96950",
    x1: 29.7769,
    y1: 52.8259,
    x2: 27.7932,
    y2: 58.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555E5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_374_96950",
    x1: 31.7742,
    y1: 58.7725,
    x2: 27.6656,
    y2: 61.2376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#4F4F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31332C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_374_96950",
    x1: 29.7769,
    y1: 52.8262,
    x2: 29.7769,
    y2: 53.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_96950"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_96950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525.072,
    height: 456.507,
    fill: "white",
    transform: "translate(-82.3887 -114.058)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_96950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.25714,
    height: 11.902,
    fill: "white",
    transform: "translate(25.1484 52.8262)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_374_96950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.01878,
    height: 5.89959,
    fill: "white",
    transform: "translate(27.7646 52.8262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberPlatinum);
export default __webpack_public_path__ + "static/media/member_platinum.b37865f20644c85d1c31436a4af51006.svg";
export { ForwardRef as ReactComponent };